export const LOGIN_IN_PROGRESS = 'LOGIN_IN_PROGRESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
//
export const LOAD_SPORTGROUPS_SUCCESS = 'LOAD_SPORTGROUPS_SUCCESS';
export const LOAD_LIVE_EVENTS = 'LOAD_LIVE_EVENTS';
export const LOAD_OPEN_BETS = 'LOAD_OPEN_BETS';
//
export const EVENT_DETAILS_LOAD_SUCCESS = 'EVENT_DETAILS_LOAD_SUCCESS';
export const EVENT_DETAILS_LOAD_FAILED = 'EVENT_DETAILS_LOAD_FAILED';
//
export const KEYS_STRIP_COMPONENTS_COMPUTED = 'KEYS_STRIP_COMPONENTS_COMPUTED';
export const DATA_CASHOUTABLE_BETS_STRIP_LOADED = 'DATA_CASHOUTABLE_BETS_STRIP_LOADED';
export const CASH_IN_BET_SUCCESS = 'CASH_IN_BET_SUCCESS';
export const CASH_IN_BET_FAIL = 'CASH_IN_BET_FAIL';
export const REMOVE_CASHED_IN_BET = 'REMOVE_CASHED_IN_BET';
export const SWITCH_BUTTON_TYPE = 'SWITCH_BUTTON_TYPE';
//
export const SESSION_EXTEND_SUCCESS = 'SESSION_EXTEND_SUCCESS';
export const KICK_USER = 'KICK_USER';
export const CHANGE_ODDS_FORMAT = 'CHANGE_ODDS_FORMAT';
export const UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
//
export const KAMBI_CLIENT_RENDERED = 'KAMBI_CLIENT_RENDERED';
export const MOBILE_LOOK = 'MOBILE_LOOK';
//
export const UPDATE_BREADCRUMBS_FROM_ROUTE = 'UPDATE_BREADCRUMBS_FROM_ROUTE';
//
export const LOAD_LIST_VIEW_SUCCESS = 'LOAD_LIST_VIEW_SUCCESS';
export const CLEAR_LIST_VIEW_DATA = 'CLEAR_LIST_VIEW_DATA';
export const LOAD_LIST_VIEW_HIGHLIGHTS_SUCCESS = 'LOAD_LIST_VIEW_HIGHLIGHTS';
//
export const EXTERNAL_CONTENT_LOADED = 'EXTERNAL_CONTENT_LOADED';
export const SHOW_EXTERNAL_CONTENT = 'SHOW_EXTERNAL_CONTENT';
//
export const LIVE_RIGHT_NOW_DATA_LOAD_SUCCESS = '[LIVE RIGHT NOW STRIP] INITIAL_DATA_LOAD_SUCCESS';
export const LIVE_RIGHT_NOW_DATA_LOAD_FAILED = '[LIVE RIGHT NOW STRIP] INITIAL_DATA_LOAD_FAIL';
export const LIVE_RIGHT_NOW_CHANGE_ACTIVE_SPORT = '[LIVE RIGHT NOW STRIP] CHANGE_ACTIVE_SPORT';
//
export const HIGHLIGHTS_DATA_LOAD_SUCCESS = '[HIGHLIGHTS STRIP] INITIAL_DATA_LOAD_SUCCESS';
export const HIGHLIGHTS_DATA_LOAD_FAILED = '[HIGHLIGHTS STRIP] INITIAL_DATA_LOAD_FAIL';
export const HIGHLIGHTS_CHANGE_ACTIVE_SPORT = '[HIGHLIGHTS STRIP] CHANGE_ACTIVE_SPORT';
//
export const DEBUG_MODE = 'DEBUG_MODE';
//
export const SET_NATIVE_UX_VERSION = 'SET_NATIVE_UX_VERSION';
//
export const SEARCH_FAVORITES = '[FAVORITES STRIP] SEARCH_FAVORITES';
export const SEARCH_FAVORITES_SUCCESS = '[FAVORITES STRIP] SEARCH_FAVORITES_SUCCESS';
export const SEARCH_FAVORITES_FAILED = '[FAVORITES STRIP] SEARCH_FAVORITES_FAILED';
export const FAVORITES_VALIDATE_AND_LOAD_INITIAL_DATA = '[FAVORITES STRIP] FAVORITES_VALIDATE_AND_LOAD_INITIAL_DATA';
export const FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_SUCCESS = '[FAVORITES STRIP] FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_SUCCESS';
export const FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_FAILED = '[FAVORITES STRIP] FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_FAILED';
export const FAVORITES_COMING_SOON = '[FAVORITES STRIP] FAVORITES_COMING_SOON';
export const FAVORITES_COMING_SOON_SUCCESS = '[FAVORITES STRIP] FAVORITES_COMING_SOON_SUCCESS';
export const FAVORITES_COMING_SOON_FAILED = '[FAVORITES STRIP] FAVORITES_COMING_SOON_FAILED';
export const FAVORITES_ENDGAME = '[FAVORITES STRIP] FAVORITES_ENDGAME';
export const FAVORITES_ENDGAME_SUCCESS = '[FAVORITES STRIP] FAVORITES_ENDGAME_SUCCESS';
export const FAVORITES_ENDGAME_FAILED = '[FAVORITES STRIP] FAVORITES_ENDGAME_FAILED';
export const FOLLOW_FAVORITE = '[FAVORITES STRIP] FOLLOW_FAVORITE';
export const FOLLOW_FAVORITE_SUCCESS = '[FAVORITES STRIP] FOLLOW_FAVORITE_SUCCESS';
export const FOLLOW_FAVORITE_FAILED = '[FAVORITES STRIP] FOLLOW_FAVORITE_FAILED';
export const UNFOLLOW_FAVORITE = '[FAVORITES STRIP] UNFOLLOW_FAVORITE';
export const UNFOLLOW_FAVORITE_SUCCESS = '[FAVORITES STRIP] UNFOLLOW_FAVORITE_SUCCESS';
export const UNFOLLOW_FAVORITE_FAILED = '[FAVORITES STRIP] UNFOLLOW_FAVORITE_FAILED';
//
export const GET_BETS_RECOMMENDATIONS = '[RECOMMENDED FOR YOU] GET_BETS_RECOMMENDATIONS';
export const GET_BETS_RECOMMENDATIONS_SUCCESS = '[RECOMMENDED FOR YOU] GET_BETS_RECOMMENDATIONS_SUCCESS';
export const GET_BETS_RECOMMENDATIONS_FAILED = '[RECOMMENDED FOR YOU] GET_BETS_RECOMMENDATIONS_FAILED';
export const EVENT_DETAILS_LOADED = '[RECOMMENDED FOR YOU] EVENT_DETAILS_LOADED';

export const TRACK_IMPRESSIONS = '[VAIX] TRACK_IMPRESSIONS';
export const TRACK_EVENT_CLICK = '[VAIX] TRACK_EVENT_CLICK';
export const TRACK_OUTCOME_CLICK = '[VAIX] TRACK_OUTCOME_CLICK';

export const SET_MENU_MAPPINGS = '[MENU] SET_MAPPINGS';
